import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Tab, Header, Loader } from 'semantic-ui-react';
import ViewProject from '../components/Projects/ViewProject';
import ManageProjectJobs from '../components/Projects/ManageProjectJobs';
import ExpertRecommendations from '../components/Projects/ExpertRecommendations';
import ProjectReport from '../components/Projects/ProjectReport';
import AiChat from '../components/AiChat';
import Security from '../utils/Security';
import PROJECT from '../queries/project';

const ProjectDetail = () => {
  const { id, tab } = useParams();
  const history = useHistory();

  const { data, loading } = useQuery(PROJECT, {
    variables: { id },
  });

  if (loading) return <Loader active />;

  const criteria = data?.project?.expertRecommendations?.criteria || [];
  const hasExpertRecommendations = criteria.length > 0;
  const hasReport = (data?.project?.aiReport?.sections || []).length > 0;

  const panes = [
    { slug: '', menuItem: 'View project', render: () => <ViewProject project={data.project} /> },
    { slug: 'manage-experts', menuItem: 'Manage experts', render: () => <ManageProjectJobs project={data.project} /> },
  ];

  if (hasExpertRecommendations) {
    panes.push({
      slug: 'expert-recommendations',
      menuItem: 'Expert recommendations',
      render: () => <ExpertRecommendations projectId={data.project.id} />,
    });
  }

  if (hasReport) {
    panes.push({
      slug: 'report',
      menuItem: 'Report',
      render: () => <ProjectReport projectId={data.project.id} />,
    });
  }

  const canUseChat = (Security.isSuperUser() || Security.isDecibio())
    && data.project.type === 'Interview'
    && data.project.hasTranscript;

  if (canUseChat) {
    panes.push({
      slug: 'ai-chat',
      menuItem: 'AI Chat',
      render: () => <AiChat scope="project" projectId={data.project.id} />,
    });
  }

  const activeIndex = Math.max(0, panes.findIndex((pane) => pane.slug === (tab || '')));

  return (
    <div id="project-detail">
      <Header>{data.project.title}</Header>
      <Tab
        menu={{ secondary: true, pointing: true }}
        panes={panes}
        activeIndex={activeIndex}
        onTabChange={(_e, { activeIndex: newIndex }) => {
          const { slug } = panes[newIndex];
          history.push(`/projects/${id}${slug ? `/${slug}` : ''}`);
        }}
      />
    </div>
  );
};

export default ProjectDetail;
